var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.noProfileReady)?_c(this.findOutWhyThereIsNoProfileReady,{tag:"component"}):(_vm.failed)?_c('api-error'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }